import {ArrowPathIcon, PencilIcon, TrashIcon} from "@heroicons/react/24/outline";
import {
    checkPerm,
    classNames,
    getProp,
    resourceIsCreated,
    resourceIsDeleted,
    resourceIsUpdated
} from "../../util/util-helpers";
import Button from "../button";
import Resources from "../../../data/services/resources";
import {CREATE_PERM} from "../../../util/util-constants";
import React, {useEffect, useState} from "react";
import InfoParagraph from "../info-paragraph";
import ResourceTable from "../resource-table";
import {DELETE_PERM, UPDATE_PERM} from "../../util/util-consts";
import CheckIcon from "@heroicons/react/24/outline/CheckIcon";
import TableCard from "../resource-table/table-components/table-card";
import {Field, FieldsManager} from "../../../data/services/fields";
import ModalSaveResource from "../modal/modal-save-resource";
import LocalStorage from "../../../util/localStorage";
import {useDispatch, useSelector} from "react-redux";
import {enumerateDaysBetweenDates} from "../../util/util-dates";
import {fillFieldsFromData} from "../../util/util-fields";
import ModalConfirm from "../modal/modal-confirm";
import NoRecordsTable from "../no-records-found/no-records-table";
import {
    clearUpdateStateSecondResource,
    createSecondResource,
    deleteSecondResource,
    getSecondResource,
    updateSecondResource
} from "../../../data/actions/secondResource";
import moment from "moment";

export default function DriverVacationsList({translate, id, title, onListChange}) {
    const dispatch = useDispatch();
    const resource = useSelector(state => state.secondResource);
    const count = getProp(resource, 'data.count', 0);
    const data = getProp(resource, 'data.list', []);
    const isLoading = resource?.isLoading ?? true;

    const query = {
        id: id
    };

    const resourcePath = Resources.DriverVacations;
    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
    const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    function fetchData() {
        dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            resource: resourcePath,
            query: query
        }))
    }

    function handleToggleUpdateDialog(item = null) {
        setSelectedItem(item);
        setIsUpdateDialogOpen(!isUpdateDialogOpen);
    }

    function handleToggleEditDialog(item = null) {
        setSelectedItem(item);
        setIsEditDialogOpen(!isEditDialogOpen);
    }

    function handleToggleConfirmDialog(item = null) {
        setSelectedItem(item);
        setIsDeleteDialogOpen(!isDeleteDialogOpen);
    }

    function addNewVacation(fields) {
        dispatch(createSecondResource({
            user: LocalStorage.get('user'),
            params: Object.assign({}, FieldsManager.getFieldKeyValues(fields), {
                DriverID: id
            }),
            query: query,
            resource: resourcePath,
            piggyResource: resourcePath,
            errorMessage: true,
            successMessage: translate('text.vacation_created'),
        }))
    }

    function getCreateFields() {
        const excludedDates = getExcludedDates(getProp(data, 'list', []));

        function getVacationDuration(startDate, endDate) {
            const start = moment(startDate);
            const end = moment(endDate).add(1, 'day');

            const totalDays = end.diff(start, 'days');

            const years = end.diff(start, 'years');
            start.add(years, 'years');

            const months = end.diff(start, 'months');
            start.add(months, 'months');

            const days = end.diff(start, 'days');

            return { totalDays, years, months, days };
        }

        function formatDuration({ years, months, days }) {
            const parts = [];
            if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
            if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
            if (days > 0 || parts.length === 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
            return parts.join(', ');
        }

        return {
            VacationID: new Field('VacationID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
            StartVacation: new Field('StartVacation', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}, {
                excludeDates: excludedDates
            }),
            EndVacation: new Field('EndVacation', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}, {
                excludeDates: excludedDates
            }),
            VacationDuration: new Field('VacationDuration', '', [''], false, 'custom', {
                render: (it) => {return (<div>{formatDuration(getVacationDuration(it?.StartVacation, it?.EndVacation))}</div>)}
            }),
            VacationTimezone: new Field('VacationTimezone', 'UTC', ['empty'], false, 'hidden', {
                hideDialog: true,
                hideTable: true
            }),
            VacationStatus: new Field('VacationStatus', '', [], false, 'text', {
                hideDialog: true,
                hideTable: !id
            }),
            RequestCreatedDateTime: new Field('RequestCreatedDateTime', '', [], false, 'datetime', {
                hideDialog: true,
                hideTable: !id
            }),
            StatusUpdateByID: new Field('StatusUpdateByID', '', [], false, 'select-search', {
                hideDialog: true,
                hideTable: !id
            }),
            Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-full'}),
        }
    }

    function getUpdateFields(item = null) {
        let fieldTemplates = {
            VacationStatusID: new Field('VacationStatusID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
        }
        return fillFieldsFromData(fieldTemplates, item)
    }

    function getEditFields(item = null) {
        const excludedDates = getExcludedDates(getProp(data, 'list', []));

        let fieldTemplates = {
            VacationID: new Field('VacationID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
            StartVacation: new Field('StartVacation', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}, {
                excludeDates: excludedDates
            }),
            EndVacation: new Field('EndVacation', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}, {
                excludeDates: excludedDates
            }),
            VacationTimezone: new Field('VacationTimezone', 'UTC', ['empty'], false, 'hidden', {
                hideTable: true
            }),
            VacationStatusID: new Field('VacationStatusID', '', [], false, 'select', {
                addContainerClass: 'col-span-full',
                hideTable: !id
            }),
            Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-full'}),
        }
        return fillFieldsFromData(fieldTemplates, item)
    }

    function getExcludedDates(data) {
        return data.reduce((memo, it) => {
            if (it.VacationStatusID !== 3) {
                return memo.concat(enumerateDaysBetweenDates(it.StartVacation, it.EndVacation))
            }
            return memo
        }, [])
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (onListChange && resource.resource === Resources.DriverVacations && (resourceIsCreated(resource) || resourceIsUpdated(resource) || resourceIsDeleted(resource))) {
            dispatch(clearUpdateStateSecondResource());
            onListChange();
        }
    }, [resource]);

    return <>
        <div className="my-2 flex gap-2">
            {title && (
                <div className="mr-5 text-2xl ml-4 mb-3">{title}</div>
            )}

            <button className="btn btn-header ml-auto" onClick={() => fetchData()}>
                <ArrowPathIcon className={classNames("w-5 h-5", isLoading ? "animate-spin" : undefined)}/>
            </button>

            <Button
                appearance="primary"
                onClick={() => setIsCreateDialogOpen(true)}
                hasPerm={checkPerm(resourcePath, CREATE_PERM)}
            >
                {translate("btn.add/create")}
            </Button>
        </div>

        <TableCard>
            <div className="p-1">
                <InfoParagraph className="" message={translate("message.VacationTabMessage")}/>
            </div>

            <ResourceTable
                addClass="rounded-card"
                data={data}
                count={count}

                tableKey='DriverVacationID'

                fields={getCreateFields()}
                translate={translate}
                options={{style: {floatingActions: true, horizontalLines: true}}}
                isLoading={isLoading}
                onRowClick={checkPerm(resourcePath, UPDATE_PERM) ? handleToggleUpdateDialog : null}
                actions={[
                    {
                        tooltipText: () => translate('btn.edit'),
                        action: handleToggleEditDialog,
                        visible: (it) => id && it.VacationStatusID === 1 && checkPerm(resourcePath, UPDATE_PERM),
                        icon: () => PencilIcon
                    },
                    {
                        tooltipText: () => translate('btn.edit_approval'),
                        action: handleToggleUpdateDialog,
                        visible: () => id && checkPerm(resourcePath, UPDATE_PERM),
                        icon: () => CheckIcon
                    },
                    {
                        tooltipText: () => translate("btn.delete"),
                        action: (it) => handleToggleConfirmDialog(it),
                        icon: () => TrashIcon,
                        visible: () => checkPerm(resourcePath, DELETE_PERM)
                    }
                ]}
            />

            <NoRecordsTable
                show={(data.length === 0) && !isLoading}
                canCreate={checkPerm(resourcePath, CREATE_PERM)}
                title={translate("text.no_records")}

                text={translate("text.create_time_off")}
                btnLabel={translate("btn_create_time_off")}
                onBtnClick={() => {
                    setIsCreateDialogOpen(true);
                }}

                clearFilterBtnLabel={translate("text.clear_all_filters")}
                clearFilterText={translate("text.try_without_filters")}
                filters={{}}
            />
        </TableCard>

        <ModalSaveResource
            show={isCreateDialogOpen}
            title={translate('text.add_new_vacation')}
            widthClass="max-w-md"
            gridColsClass="grid-cols-3"
            onClose={() => setIsCreateDialogOpen(false)}
            fields={getCreateFields()}
            getRawFields
            onSubmit={(params) => {
                if (params) {
                    addNewVacation(params);
                    setIsCreateDialogOpen(false);
                }
            }}
            translate={translate}
            handleInputChange={(fields, name, value) => {
                return FieldsManager.updateField(fields, name, value)
            }}
        />

        <ModalSaveResource
            show={isUpdateDialogOpen}
            title={translate('text.EditApproval')}
            widthClass="max-w-md"
            gridColsClass="grid-cols-3"
            onClose={() => setIsUpdateDialogOpen(false)}
            fields={getUpdateFields(selectedItem)}
            onSubmit={(params) => {
                if (params) {
                    params['DriverVacationID'] = selectedItem?.['DriverVacationID']
                    dispatch(updateSecondResource({
                        user: LocalStorage.get('user'),
                        params: params,
                        query: query,
                        resource: resourcePath,
                        piggyResource: resourcePath,
                        errorMessage: true,
                        successMessage: translate('text.DriverVacationStatusUpdated'),
                    }))

                    setIsUpdateDialogOpen(false);
                }
            }}
            translate={translate}
        />

        <ModalSaveResource
            show={isEditDialogOpen}
            title={translate('text.Edit_time_off')}
            widthClass="max-w-md"
            gridColsClass="grid-cols-3"
            onClose={() => handleToggleEditDialog()}
            fields={getEditFields(selectedItem)}
            onSubmit={(params) => {
                if (params) {
                    params['DriverVacationID'] = selectedItem?.['DriverVacationID']
                    dispatch(updateSecondResource({
                        user: LocalStorage.get('user'),
                        params: params,
                        query: query,
                        resource: resourcePath,
                        piggyResource: resourcePath,
                        errorMessage: true,
                        successMessage: translate('text.DriverVacationStatusUpdated'),
                    }))

                    handleToggleEditDialog();
                }
            }}
            translate={translate}
        />

        <ModalConfirm
            title={'Confirm'}
            show={isDeleteDialogOpen}
            text={translate('message.confirm_delete_generic', [selectedItem?.Vacation])}
            onClose={() => setIsDeleteDialogOpen(false)}
            buttonLabel={translate('btn.confirm')}
            closeButtonLabel={'Cancel'}
            translate={translate}
            onConfirm={() => {
                dispatch(deleteSecondResource({
                    user: LocalStorage.get('user'),
                    query: Object.assign({}, query, {
                        DriverVacationID: selectedItem?.DriverVacationID,
                    }),
                    errorMessage: true,
                    successMessage: translate('text.DriverVacationDeleted'),
                    resource: resourcePath,
                    secondPiggyResource: resourcePath
                }))
                setIsDeleteDialogOpen(false);
            }}
        />
    </>

}